module.exports = __webpack_public_path__ + "img/sign-35.0e2a679a.jpg";